import { useSelector } from 'react-redux'

import { getPlacements } from 'state/ads/selectors'
import { getSystemConfiguration } from 'state/system-configuration/selectors'

import DirectSetup from './components/DirectSetup'
import RtbSetup from './components/RtbSetup'

const AdScripts = () => {
  const systemConfiguration = useSelector(getSystemConfiguration)
  const placements = useSelector(getPlacements)

  if (!placements.length) return null

  const isLtUser = systemConfiguration?.userCountry === 'lt'

  return isLtUser ? <DirectSetup /> : <RtbSetup />
}

export default AdScripts
